<template>
  <div class="mysection">
    <div class="mycustem">
      <h3>
        我介绍的客户
        <div class="list_title_right">共<span class="color_red">{{this.referrerCount}}</span>位</div>
      </h3>
      <ul>
        <li v-for="item in customersArray">
          <!--<img :src="item.headimgurl" />-->
          <img :src="'data:image/jpg;base64,'+item.headimgurl"/>
          <div class="mclist">
            {{item.username}} <br>
            <p>{{item.phoneNumber}}</p>
          </div>
          <span class="mcdate">{{item.createTime|date_from_unix_YearMonthDay}}</span>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
  import {reqMyCustomerInfo} from  '../../api/weixin-api'
  export  default {
    data(){
      return{
          userId:'',
        referrerCount:0,
        customersArray:[],
      }
    },
    methods:{
      getMyCustomer(userId){
        reqMyCustomerInfo({userId:userId}).then((res)=>{
          if(res.data.code===1){
            this.customersArray=res.data.data.Customers;
            this.referrerCount=res.data.data.referrerCount
          }
        })
      },
      isWechatBrowser: function () {
        let that=this;
        let ua = navigator.userAgent.toLowerCase();
        let isWeixin = ua.indexOf('micromessenger') !== -1;
        if (!isWeixin) {
          that.$router.push({name: 'wxError'});
        }
      },
      backWeiXin:function() {
        pushHistory();
        function bodyScroll(){
          window.location.href='/wxMyHomePage';
        }
        window.addEventListener("popstate",bodyScroll, false);
        function pushHistory() {
          var state = {
            title: "title",
            url: ""
          };
          window.history.pushState(state, state.title, state.url);
        }
      }
    },
    mounted(){
      this.$store.dispatch('hideHF');
       this.userId=this.$route.query.id;
       console.info("iiii===="+this.userId)
      this.isWechatBrowser();
      if(this.userId){
         this.getMyCustomer(this.userId);

      }
      this.backWeiXin()
    },
  }
</script>
<style slot-scope="scope">
  @import '../../assets/css/wxstyle.css';
</style>



// WEBPACK FOOTER //
// src/components/weChat/WxMyCustomer.vue